export default __webpack_public_path__ + "assets/a994c299f037e2f1ad94b4b1956d4a95.jpeg";